import { IListDetailsStatusSetAction } from './types';
import { AT_STATUS_SET } from './constants';

export const listDetailsStatusActionSet = (
    status: string
): IListDetailsStatusSetAction => ({
    type: AT_STATUS_SET,
    status
});
